export {default as VideoPlayer} from './videoPlayer';
